function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M233.9 78h-49.5c9.8-23.5-1.3-50.5-24.9-60.3S108.9 19 99.1 42.6c-4.7 11.4-4.7 24.1 0 35.5H49.6L14.2 269.3h255.1L233.9 78zm-92.2-35.3c9.7 0 17.6 7.9 17.6 17.6s-7.9 17.6-17.6 17.6c-9.7 0-17.6-7.9-17.6-17.6 0-9.7 7.9-17.6 17.6-17.6zm-68.4 63.8h136.8L235 240.8H48.4l24.9-134.3z"
})));